/* eslint-disable prettier/prettier */
const btnMenuOpen = document.querySelector("#menuMobileToggle");
const mobileMenu = document.querySelector(".navbar");
const btnMenuClose = document.querySelector("#menuMobileClose");
//const submenu = document.querySelectorAll(".menu-mobile-list .hasSubmenu");
const btnVariableTab = document.querySelectorAll(".variableTab");

export default class MenuToggle {
  static toggle = function () {
    btnMenuOpen.addEventListener("click", function () {
      //toggle modal
      mobileMenu.classList.add("open");
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      /*mobileMenu.classList.contains("open")
        ? (mobileMenu.classList.remove("open"),
          (document.body.style.overflow = "auto"),
          (document.documentElement.style.overflow = "auto"))
        : (mobileMenu.classList.add("open"),
          (document.body.style.overflow = "hidden"),
          (document.documentElement.style.overflow = "hidden"));
          */
    });
    btnMenuClose.addEventListener("click", function () {
      mobileMenu.classList.remove("open");
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "";
    });
  };

  static initSubmenu = function () {
    document.querySelectorAll(".mobile-submenu-toggle").forEach((btn) => {
      btn.addEventListener("click", function () {
        const item = this.closest(".has-mobile-submenu");
        const submenu = item.querySelector(".mobile-submenu");
        const expanded = this.getAttribute("aria-expanded") === "true";
        // aprendo una voce, chiude i fratelli già aperti
        if (!expanded) {
          item.parentElement.querySelectorAll(":scope > .has-mobile-submenu").forEach((sibling) => {
            if (sibling === item) return;
            sibling.querySelector(".mobile-submenu").classList.remove("open");
            sibling.querySelector(".mobile-submenu-toggle").setAttribute("aria-expanded", "false");
          });
        }
        this.setAttribute("aria-expanded", String(!expanded));
        submenu.classList.toggle("open", !expanded);
      });
    });

    document.querySelectorAll(".has-mobile-submenu .nav-item-row .nav-link").forEach((link) => {
      link.addEventListener("click", function (e) {
        if (window.innerWidth <= 992) {
          e.preventDefault();
          const btn = this.closest(".nav-item-row").querySelector(".mobile-submenu-toggle");
          if (btn) btn.click();
        }
      });
    });
  };

  static variableTab = function () {
    btnVariableTab.forEach((btn) => {
      btn.addEventListener("click", function () {
        const tab = this.closest(".product-variants-tabs");
        const expanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", String(!expanded));
        tab.classList.toggle("is-open", !expanded);
      });
    });
  };

  static init() {
    MenuToggle.toggle();
    MenuToggle.initSubmenu();
    if (btnVariableTab.length > 0) {
      MenuToggle.variableTab();
    }
  }
}
